import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { postItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { CreditNote, formatCreditNoteNumber } from "../../models/credit-note";

interface CreditNoteSendEmailProps {
  show: boolean;
  creditNote?: CreditNote;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const CreditNoteSendEmailModal: React.FC<CreditNoteSendEmailProps> = ({
  show,
  creditNote,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const taxPayer = useSelector(
    (state: RootState) => state.taxPayer.data.taxPayer
  );

  const message = creditNote
    ? `Está seguro de que enviar el correo para la nota de crédito ${formatCreditNoteNumber(
        creditNote
      )}?`
    : "";

  const onSendEmailClick = async () => {
    if (creditNote !== undefined) {
      setSubmitting(true);
      const status = await postItem(`/credit_notes/send_email/`, {
        taxPayerId: taxPayer.id,
        creditNoteIds: [creditNote.id],
      });

      if (status.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (status.detail !== undefined) {
          message = status.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-info" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Enviar por Correo</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onSendEmailClick} color="info">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Enviando..." : "Enviar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default CreditNoteSendEmailModal;
